import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import apiClient from "../../api/Api.js";

const UserPopUp = ({ open, onClose, user }) => {
  const [projects, setProjects] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (open && user?.email) {
      fetchProjects(user.user_id);
    }
  }, [open, user]);

  const fetchProjects = async (user_id) => {
    setIsLoading(true);
    setIsError(false);
    try {
      const response = await apiClient.get(
        `${process.env.REACT_APP_AUTH_USER}/getprojects/${user_id}`
      );
      setProjects(response.data || []);
    } catch (error) {
      console.error("Error fetching projects:", error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectProject = (project) => {
    setSelectedProjects((prevSelected) =>
      prevSelected.includes(project)
        ? prevSelected.filter((item) => item !== project)
        : [...prevSelected, project]
    );
  };

  const handleDeleteProjects = async () => {
    try {
      // Call API to delete selected projects
    //  console.log(selectedProjects);

      await apiClient.delete(
        `${process.env.REACT_APP_AUTH_USER}/deleteprojects/${user.user_id}`,
        {
          data: { projects: selectedProjects },
        }
      );
      // Remove deleted projects from the list
      setProjects((prevProjects) =>
        prevProjects.filter((project) => !selectedProjects.includes(project))
      );
      setSelectedProjects([]);
    } catch (error) {
      console.error("Error deleting projects:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle textAlign="center">User Projects</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" p={2}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Typography color="error" textAlign="center">
            Failed to load project details.
          </Typography>
        ) : projects.length > 0 ? (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {projects.map((project, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card
                  variant="outlined"
                  sx={{
                    boxShadow: 2,
                    "&:hover": {
                      boxShadow: 4,
                    },
                    borderRadius: 2,
                  }}
                >
                  <CardContent>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedProjects.includes(project)}
                          onChange={() => handleSelectProject(project)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          textAlign="center"
                          fontWeight="bold"
                          color="primary"
                        >
                          {project}
                        </Typography>
                      }
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography textAlign="center" sx={{ mt: 2 }}>
            No project details available.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={onClose} variant="contained" color="secondary">
          Close
        </Button>
        <Button
          onClick={handleDeleteProjects}
          variant="contained"
          color="error"
          disabled={selectedProjects.length === 0}
        >
          Delete Selected
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserPopUp;
